import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImages2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"images-2, photos, pictures, shot"} maskId="square-filled-radius-0-stroke-1-IconImages2"><path d="M16.5 9.5C16.5 10.6046 15.6046 11.5 14.5 11.5C13.3954 11.5 12.5 10.6046 12.5 9.5C12.5 8.39543 13.3954 7.5 14.5 7.5C15.6046 7.5 16.5 8.39543 16.5 9.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V21H21V3ZM8 11.2929L4 15.2929V4H20V20H16.7071L8 11.2929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImages2;
